import agencyApi from 'api/agencyApi';
import chargeModelApi from 'api/chargeModelApi';
import saleApi from 'api/saleApi';
import agencySaleReportApi from 'features/DealerReconciliationReport/agencySaleReportApi';
import DealerHelper from 'features/ManageDealer/dealerHelper';
import { FastField, Field, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTRadio, {
  KTRadioType,
} from 'general/components/OtherKeenComponents/KTFormControls/KTRadio';
import KTOverlay from 'general/components/OtherKeenComponents/KTOverlay';
import InputSearchDropdown from 'general/components/Others/InputSearchDropdown';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import _, { pick } from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

function DealerReconciliationReportDetailScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const query = router.query;
  const orderId = query?.orderId;
  const dealerId = query?.dealerId;
  const isEditMode = !_.isUndefined(orderId) && _.isNumber(parseInt(orderId));
  const [orderDetail, setOrderDetail] = useState();
  const [agencyDetail, setAgencyDetail] = useState();
  const [productType, setProductType] = useState('station');
  const refFormik = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const selectFilePathList = useRef([]);
  const [allFiles, setAllFiles] = useState([]);

  const [packageList, setPackageList] = useState([
    {
      name: 'Gói đầu tư thần tốc',
      value: 1,
    },
    {
      name: 'Gói đầu tư thần kỳ',
      value: 2,
    },
  ]);

  useScrollToTop();

  useEffect(() => {
    setAllFiles(orderDetail?.attachedFiles ?? []);
  }, [orderDetail]);
  const orderStatusOptions = useMemo(() => {
    return [
      {
        name: t(`orderStatus_${AppConstants.orderStatus.ordered}`),
        value: AppConstants.orderStatus.ordered,
      },
      {
        name: t(`orderStatus_${AppConstants.orderStatus.shipping}`),
        value: AppConstants.orderStatus.shipping,
      },
      {
        name: t(`orderStatus_${AppConstants.orderStatus.installing}`),
        value: AppConstants.orderStatus.installing,
      },
      {
        name: t(`orderStatus_${AppConstants.orderStatus.installed}`),
        value: AppConstants.orderStatus.installed,
      },
      {
        name: t(`orderStatus_${AppConstants.orderStatus.completed}`),
        value: AppConstants.orderStatus.completed,
      },
    ];
  }, [t]);
  const { user } = useSelector((state) => state.auth);
  useEffect(() => {
    if (orderId && isEditMode) {
      agencySaleReportApi.getOrderDetail(orderId).then((data) => {
        const { result, sale } = data;
        if (result === 'success') {
          setOrderDetail(sale);
        }
      });
    }
  }, [orderId, isEditMode]);
  useEffect(() => {
    if (dealerId) {
      DealerHelper.callApiGetAgencyDetail(dealerId).then((data) => {
        setAgencyDetail(data);
      });
    }
  }, [dealerId]);
  // ds hang dieu hanh
  const operatorList = useSelector((state) => state?.app?.appConfig?.operators) ?? [];
  const operatorOptions = useMemo(() => {
    return operatorList?.map((row) => {
      return {
        title: row?.name,
        subTitle: row?.description,
        value: row?.operatorId,
      };
    });
  }, [operatorList]);
  // ds nha dau tu
  const [investorList, setInvestorList] = useState([]);
  useEffect(() => {
    agencyApi.getAgencyList({ type: AppConstants.agencyType.investor }).then((data) => {
      const { result, agencies } = data;
      if (result === 'success') {
        setInvestorList(agencies);
      }
    });
  }, []);
  const investorOptions = useMemo(() => {
    return investorList?.map((row) => {
      return {
        title: row?.name,
        subTitle: row?.description,
        value: row?.agencyId,
      };
    });
  }, [investorList]);
  // ds charge models
  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const data = await chargeModelApi.getChargeModelList({});
        const { result, models } = data;
        if (result === 'success') {
          setModelList([...models]);
        }
      } catch (error) {
        console.error('Error fetching models:', error);
      }
    };

    fetchModels();
  }, []);

  // ---- methods ----
  const buildCard = (
    title,
    contentEl = <></>,
    additionalClassName = '',
    rounded = true,
    borderRight = false,
    style = {},
    fontColor = AppColors.gray[900],
    bgColor,
    shadow = true
  ) => {
    return (
      <div
        className={`${shadow ? 'shadow' : ''}`}
        style={{
          borderRadius: rounded ? '10px' : '0px',
          border: `${borderRight ? '0px' : '1px'} solid ${AppColors.gray[300]}`,
          backgroundColor: 'white',
          ...pick(style, ['borderBottomRightRadius', 'borderBottomLeftRadius']),
        }}
      >
        <div
          className="px-4 py-3 w-100"
          style={{
            fontWeight: '600',
            fontSize: '14px',
            color: fontColor,
            background: bgColor,
          }}
        >
          {title}
        </div>
        <div
          className={`pb-4 ${additionalClassName}`}
          style={{
            ...style,
          }}
        >
          <div className="">{contentEl}</div>
        </div>
      </div>
    );
  };
  const handleSave = () => {
    refFormik?.current?.handleSubmit();
  };
  const handleFilesChanged = (e) => {
    const newFiles = Array.from(e.target.files || []);

    const validFiles = newFiles.filter((file) => {
      if (file.name.length > 128) {
        ToastHelper.showError(`Tên file quá dài! Tối đa cho phép 128 ký tự.`);
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    setSelectedFiles((prev) => [...prev, ...validFiles]);
    setAllFiles((prev) => [...prev, ...validFiles]);
  };

  const handleRemoveAll = () => {
    setSelectedFiles([]);
  };

  const handleViewFile = (file) => {
    const url = URL.createObjectURL(file);
    if (url) {
      Utils.openInNewTab(url);
      URL.revokeObjectURL(url);
    }
  };

  const handleRemoveFile = (file) => {
    if (file instanceof File) {
      const tmpFiles = selectedFiles.filter((item) => item.lastModified !== file?.lastModified);
      setSelectedFiles(tmpFiles);
    }

    let newAllFiles = [...allFiles];
    if (typeof file === 'string') {
      newAllFiles = _.filter(allFiles, (item) => item !== file);
    }
    if (file instanceof File) {
      newAllFiles = _.filter(allFiles, (item) => item.lastModified !== file?.lastModified);
    }
    setAllFiles(newAllFiles);
  };

  async function processSelectedFiles(files) {
    for (const file of files) {
      const path = await uploadAsyncFunction(file);
      selectFilePathList.current?.push(path);
    }
  }

  async function uploadAsyncFunction(file) {
    return new Promise((resolve) => {
      if (file instanceof File) {
        miscHelper.callApiUploadFile(file).then((mediaList) => {
          if (_.isArray(mediaList) && mediaList.length > 0) {
            const firstMedia = _.first(mediaList);
            const relativePath = firstMedia?.relativePath;
            if (relativePath) {
              resolve(relativePath);
            } else {
              resolve(null);
            }
          } else {
            resolve(null);
          }
        });
      } else {
        resolve(file);
      }
    });
  }

  const handleSubmit = async (values) => {
    if (!_.isEmpty(selectedFiles)) {
      selectFilePathList.current = [];
      await processSelectedFiles(selectedFiles);
    }
    setAllFiles([
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ]);

    const params = {
      amount: parseInt(values?.productPrice ?? '0'),
      note: values?.orderNote,
      serialNumber: values?.productSerial,
      contractNumber: values?.orderNumber,
      time: values?.orderDate,
      operatorId: values?.operatorId,
      agencyId: values?.agencySaleId,
      buyerId: values?.agencyInvestorId,
      modelId: values?.productId,
      status: values?.orderStatus,
    };
    const attachedFiles = [
      ..._.filter(allFiles, (item) => typeof item === 'string'),
      ...selectFilePathList.current,
    ];
    params.attachedFiles = attachedFiles;
    setSelectedFiles([]);
    selectFilePathList.current = [];
    let ret = {};
    try {
      if (isEditMode) {
        ret = await saleApi.updateSale(orderDetail?.saleId, params);
      } else {
        ret = await saleApi.createSale(params);
      }
    } catch (error) {
      ret = error?.response?.data;
    }

    console.log({ ret });
    const { result, reason } = ret;
    if (result === 'success') {
      if (isEditMode) {
        ToastHelper.showSuccess(t('Cập nhật đơn hàng thành công'));
      } else {
        ToastHelper.showSuccess(t('Tạo đơn hàng thành công'));
      }
      router.navigate(`${AppRoute.saleReport}#order-history`);
    } else {
      if (isEditMode) {
        ToastHelper.showError(t('Cập nhật đơn hàng không thành công: ' + reason));
      } else {
        ToastHelper.showError(t('Tạo đơn hàng không thành công: ' + reason));
      }
    }
  };

  const breadcrumPath = localStorage.getItem('breadcrumPath');
  const parsedPath = breadcrumPath ? JSON.parse(breadcrumPath) : [];

  return (
    <div className={`${parsedPath?.length > 1 ? 'mt-12' : ''}`}>
      {/* header */}
      <div
        className="w-100 bg-white px-5 py-4 shadow"
        style={{
          borderRadius: '10px',
          border: `1px solid ${AppColors.gray[300]}`,
          fontWeight: '700',
          fontSize: Utils.convertToFontSize(15),
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          {/* breadcrumb */}
          <div className="d-flex flex-wrap flex-row align-items-center gap-2 flex-grow-1">
            <a
              href="#"
              className="d-flex align-items-center gap-2"
              style={{
                fontWeight: '600',
                fontSize: '18px',
                color: AppColors.gray[900],
                pointerEvents: 'none',
              }}
            >
              {isEditMode ? 'Chi tiết đơn hàng' : 'Tạo đơn hàng'}
            </a>
          </div>
          <KTBSButton
            color={KTBSButtonColor.light}
            title="Hủy bỏ"
            size={KTBSButtonSize.default}
            borderRadius={5}
            buttonTitleFontWeight="600"
            buttonTitleColor="#000000"
            additionalClassName="mr-3"
            buttonTitleFontSize={14}
            onPress={() => { }}
          />
          <KTBSButton
            color={KTBSButtonColor.success}
            title="Tạo đơn hàng"
            size={KTBSButtonSize.default}
            borderRadius={5}
            buttonTitleFontWeight="600"
            buttonTitleColor="#fff"
            additionalClassName=""
            buttonTitleFontSize={14}
            onPress={handleSave}
          />
        </div>
      </div>

      {/* body */}
      <div className="mt-4">
        <Formik
          initialValues={{
            // thong tin ben ban
            operatorId: orderDetail?.seller?.operatorId ?? '',
            operatorName: orderDetail?.seller?.name ?? '',
            operatorPhone: orderDetail?.seller?.phone ?? '',
            operatorEmail: orderDetail?.seller?.email ?? '',
            operatorAddress: orderDetail?.seller?.address ?? '',
            // dai ly ban hang
            agencySaleId: dealerId ? agencyDetail?.agencyId : user?.agency?.agencyId ?? '',
            agencySaleName: dealerId ? agencyDetail?.name : user?.agency?.name ?? '',
            agencySalePhone: dealerId ? agencyDetail?.phone : user?.agency?.phone ?? '',
            agencySaleEmail: dealerId ? agencyDetail?.email : user?.agency?.email ?? '',
            agencySaleAddress: dealerId ? agencyDetail?.address : user?.agency?.address ?? '',
            // nha dau tu
            agencyInvestorId: orderDetail?.buyer?.agencyId ?? '',
            agencyInvestorName: orderDetail?.buyer?.name ?? '',
            agencyInvestorPhone: orderDetail?.buyer?.phone ?? '',
            agencyInvestorEmail: orderDetail?.buyer?.email ?? '',
            agencyInvestorAddress: orderDetail?.buyer?.address ?? '',
            // san pham
            productId: orderDetail?.modelId ?? '',
            productName: orderDetail?.model?.name ?? '',
            productSerial: orderDetail?.serialNumber ?? '',
            productPrice: orderDetail?.amount ?? 0,
            // thong tin don hang
            orderStatus: orderDetail?.status ?? AppConstants.orderStatus.ordered,
            orderDate: orderDetail
              ? Utils.formatDateTimeToString(orderDetail?.time, 'YYYY-MM-DD')
              : Utils.formatDateTimeToString(moment().toDate(), 'YYYY-MM-DD'),
            orderNumber: orderDetail?.contractNumber ?? '',
            // ghi chu
            orderNote: orderDetail?.note ?? '',
          }}
          validationSchema={Yup.object({
            // thong tin ben ban
            operatorId: Yup.string().required(t('Bạn chưa nhập thông tin bên bán')),
            // dai ly ban hang
            agencySaleId: Yup.string().required(t('Bạn chưa nhập thông tin đại lý bán hàng')),
            // nha dau tu
            agencyInvestorId: Yup.string().required(t('Bạn chưa nhập thông tin bên mua')),
            // san pham
            productId: Yup.string().required(t('Bạn chưa nhập thông tin sản phẩm')),
            productSerial: Yup.string()
              .required(t('Bạn chưa nhập serial sản phẩm'))
              .test('len', t('invalid', { field: 'productSerial' }), (val) => {
                if (val) {
                  return val.toString().trim();
                }
              }),
            productPrice: Yup.number()
              .required(t('Bạn chưa nhập giá sản phẩm'))
              .min(1, t('Giá sản phẩm không hợp lệ')),
            // thong tin don hang
            orderNumber: Yup.string()
              .required(t('Bạn chưa nhập số hợp đồng'))
              .test('len', t('invalid', { field: 'orderNumber' }), (val) => {
                if (val) {
                  return val.toString().trim();
                }
              }),
          })}
          enableReinitialize
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {(formikProps) => {
            refFormik.current = formikProps;
            return (
              <>
                <div
                  className="shadow mb-4 bg-white"
                  style={{
                    borderRadius: '10px',
                    border: `1px solid ${AppColors.gray[300]}`,
                  }}
                >
                  <div
                    className="w-100 px-4 py-3"
                    style={{
                      fontWeight: '600',
                      fontSize: '14px',
                      color: AppColors.gray[900],
                    }}
                  >
                    Thông tin các bên tham gia
                  </div>
                  <div className="row m-0">
                    {/* thong tin ben ban */}
                    <div className="col-lg-4 px-0 pr-0">
                      {buildCard(
                        'Thông tin bên bán',
                        <div className="py-4 px-5">
                          {/* nha dieu hanh */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('operator')} </span>}
                            inputName="operatorId"
                            isRequired={true}
                            inputElement={
                              <Field name="operatorId">
                                {({ field, form, meta }) => {
                                  return (
                                    <InputSearchDropdown
                                      inputName={field.name}
                                      selectedValue={field.value}
                                      onSelectedValueChanged={(value) => {
                                        form.setFieldValue(field.name, value);
                                        const selectedOperator = _.find(
                                          operatorList,
                                          (row) => row?.operatorId == value
                                        );
                                        formikProps.setFieldValue(
                                          'operatorName',
                                          selectedOperator?.name ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'operatorPhone',
                                          selectedOperator?.phone ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'operatorEmail',
                                          selectedOperator?.email ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'operatorAddress',
                                          selectedOperator?.address ?? ''
                                        );
                                      }}
                                      items={operatorOptions}
                                      onSubmitSearch={(text) => {
                                        console.log({ text });
                                      }}
                                      selectedText={formikProps?.values?.operatorName}
                                      disabled={isEditMode}
                                    />
                                  );
                                }}
                              </Field>
                            }
                          />
                          {/* so dien thoai */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('phone')} </span>}
                            inputName="operatorPhone"
                            inputElement={
                              <FastField name="operatorPhone">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.telephone}
                                      placeholder={t('phone')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* email */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('email')} </span>}
                            inputName="operatorEmail"
                            inputElement={
                              <FastField name="operatorEmail">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.email}
                                      placeholder={t('email')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* dia chi */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('address')} </span>}
                            inputName="operatorAddress"
                            additionalClassName="mb-0"
                            inputElement={
                              <FastField name="operatorAddress">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.text}
                                      placeholder={t('address')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                        </div>,
                        '',
                        false,
                        true,
                        {
                          borderBottomLeftRadius: '10px',
                          borderRight: '1px dashed #E0E0E0',
                        },
                        '#FFFFFF',
                        'rgba(92, 120, 202, 1)',
                        false
                      )}
                    </div>
                    {/* dai ly ban hang */}
                    <div className="col-lg-4 px-0 pr-0">
                      {buildCard(
                        'Đại lý bán hàng',
                        <div className="px-5 py-4">
                          {/* ten dai ly */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('agencyName')} </span>}
                            isRequired={true}
                            inputName="agencySaleId"
                            inputElement={
                              <FastField name="agencySaleId">
                                {({ field, form, meta }) => {
                                  return (
                                    <InputSearchDropdown
                                      inputName={field.name}
                                      selectedValue={field.value}
                                      onSelectedValueChanged={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      items={[
                                        {
                                          title: 'Nguyen Van A',
                                          subTitle: '0987654321',
                                          value: 'a',
                                        },
                                      ]}
                                      onSubmitSearch={(text) => {
                                        console.log({ text });
                                      }}
                                      selectedText={formikProps.values.agencySaleName}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* so dien thoai */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('phone')} </span>}
                            inputName="agencySalePhone"
                            inputElement={
                              <FastField name="agencySalePhone">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.telephone}
                                      placeholder={t('phone')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* email */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('email')} </span>}
                            inputName="agencySaleEmail"
                            inputElement={
                              <FastField name="agencySaleEmail">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.email}
                                      placeholder={t('email')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* dia chi */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('address')} </span>}
                            inputName="agencySaleAddress"
                            additionalClassName="mb-0"
                            inputElement={
                              <FastField name="agencySaleAddress">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.text}
                                      placeholder={t('address')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                        </div>,
                        '',
                        false,
                        true,
                        {
                          borderRight: '1px dashed #E0E0E0',
                        },
                        '#FFFFFF',
                        'rgba(92, 184, 202, 1)',
                        false
                      )}
                    </div>
                    {/* thong tin ben mua */}
                    <div className="col-lg-4 px-0">
                      {buildCard(
                        'Thông tin bên mua',
                        <div className="py-4 px-5">
                          {/* nha dau tu */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('investorName')} </span>}
                            isRequired={true}
                            inputName="agencyInvestorId"
                            inputElement={
                              <Field name="agencyInvestorId">
                                {({ field, form, meta }) => {
                                  return (
                                    <InputSearchDropdown
                                      inputName={field.name}
                                      selectedValue={field.value}
                                      onSelectedValueChanged={(value) => {
                                        form.setFieldValue(field.name, value);
                                        const selectedInvestor = _.find(
                                          investorList,
                                          (row) => row?.agencyId == value
                                        );
                                        formikProps.setFieldValue(
                                          'agencyInvestorName',
                                          selectedInvestor?.name ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'agencyInvestorPhone',
                                          selectedInvestor?.phone ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'agencyInvestorEmail',
                                          selectedInvestor?.email ?? ''
                                        );
                                        formikProps.setFieldValue(
                                          'agencyInvestorAddress',
                                          selectedInvestor?.address ?? ''
                                        );
                                      }}
                                      items={investorOptions}
                                      onSubmitSearch={(text) => {
                                        console.log({ text });
                                      }}
                                      selectedText={formikProps?.values?.agencyInvestorName}
                                      disabled={!_.isUndefined(orderDetail)}
                                    // enableCheckValid={true}
                                    // isTouched={meta.touched}
                                    // isValid={_.isEmpty(meta.error)}
                                    // feedbackText={meta.error}
                                    // onBlur={() => {
                                    //   form.setFieldTouched(field.name, true);
                                    // }}
                                    />
                                  );
                                }}
                              </Field>
                            }
                          />
                          {/* so dien thoai */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('phone')} </span>}
                            inputName="agencyInvestorPhone"
                            inputElement={
                              <FastField name="agencyInvestorPhone">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.telephone}
                                      placeholder={t('phone')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* email */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('email')} </span>}
                            inputName="agencyInvestorEmail"
                            inputElement={
                              <FastField name="agencyInvestorEmail">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.email}
                                      placeholder={t('email')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* dia chi */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('address')} </span>}
                            inputName="agencyInvestorAddress"
                            additionalClassName="mb-0"
                            inputElement={
                              <FastField name="agencyInvestorAddress">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.text}
                                      placeholder={t('address')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                        </div>,
                        '',
                        false,
                        true,
                        {
                          borderBottomRightRadius: '10px',
                        },
                        '#FFFFFF',
                        'rgba(92, 202, 136, 1)',
                        false
                      )}
                    </div>
                  </div>
                </div>

                <div className="row m-0">
                  {/* san pham */}
                  <div className="col-lg-8 px-0">
                    <div className="px-0 pr-0 pr-lg-4 pb-4">
                      {buildCard(
                        'Thông tin sản phẩm',
                        <div className="">
                          <Col md={12} className="px-0">
                            <div
                              className="mb-2"
                              style={{
                                borderBottom: `1px solid ${AppColors.gray[300]}`,
                              }}
                            />
                          </Col>
                          <Formik
                            initialValues={{
                              investments: [],
                              type: 'station',
                            }}
                            onSubmit={(values) => console.log(values)}
                          >
                            {({ values, setFieldValue, resetForm }) => (
                              <div className="pt-3">
                                <div className="flex gap-4 mb-4">
                                  <KTFormGroup
                                    inputName="type"
                                    additionalClassName="fv-plugins-icon-container mb-2"
                                    additionalLabelClassName="mb-0 font-size-h6 font-weight-bolder text-gray-700 mb-2"
                                    inputElement={
                                      <div className="radio-inline w-70 px-5">
                                        <FastField name="type">
                                          {({ field, form, meta }) => (
                                            <div className="row w-100">
                                              <div className="col-3">
                                                <KTRadio
                                                  name={field.name + 'station'}
                                                  checked={field.value == 'station'}
                                                  label={'Trụ sạc'}
                                                  type={KTRadioType.outline}
                                                  additionalClassName="radio-success"
                                                  onChange={(value) => {
                                                    form.setFieldValue(field.name, 'station');
                                                    setProductType('station');
                                                    resetForm({
                                                      values: {
                                                        investments: [],
                                                        type: 'station',
                                                      },
                                                    });
                                                  }}
                                                  enableCheckValid
                                                  isValid={_.isEmpty(meta.error)}
                                                  isTouched={meta.touched}
                                                  feedbackText={meta.error}
                                                />
                                              </div>
                                              <div className="col-7 pl-7">
                                                <KTRadio
                                                  name={field.name + 'package'}
                                                  checked={field.value == 'package'}
                                                  label={'Gói đầu tư HTKD'}
                                                  type={KTRadioType.outline}
                                                  additionalClassName="radio-success"
                                                  onChange={(value) => {
                                                    form.setFieldValue(field.name, 'package');
                                                    setProductType('package');
                                                    resetForm({
                                                      values: {
                                                        investments: [],
                                                        type: 'package',
                                                      },
                                                    });
                                                  }}
                                                  enableCheckValid
                                                  isValid={_.isEmpty(meta.error)}
                                                  isTouched={meta.touched}
                                                  feedbackText={meta.error}
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </FastField>
                                      </div>
                                    }
                                  />
                                </div>
                                {productType === 'station' ? (
                                  <>
                                    <table className="table">
                                      <thead>
                                        <tr>
                                          <th className="w-40">Sản phẩm</th>
                                          <th className="w-25">Số Seri</th>
                                          <th className="w-25">Đơn giá</th>
                                          <th className="w-10"></th>
                                        </tr>
                                      </thead>
                                    </table>
                                    {values.investments.map((pkg, index) => (
                                      <tr
                                        key={pkg.id}
                                        className="flex items-center gap-4 mb-2 w-100"
                                      >
                                        <td className="w-40">
                                          {modelList.length > 0 && (
                                            <KTFormGroup
                                              inputName={`investments.${index}.value`}
                                              inputElement={
                                                <FastField name={`investments.${index}.value`}>
                                                  {({ field, form }) => {
                                                    return (
                                                      <KTBSDropdown
                                                        toggleElement={
                                                          <button
                                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                                            type="button"
                                                          >
                                                            {modelList.find(
                                                              (item) => item.modelId === field.value
                                                            )?.name ?? 'Chọn sản phẩm'}
                                                          </button>
                                                        }
                                                        selectedValue={field.value}
                                                        dropdownMenuItems={modelList.map((item) => {
                                                          return {
                                                            name: item.name,
                                                            value: item.modelId,
                                                          };
                                                        })}
                                                        dropdownMenuClassName="overflow-auto w-100"
                                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                        onChange={(value) => {
                                                          form.setFieldValue(field.name, value);
                                                        }}
                                                        isDropdownForm={true}
                                                      />
                                                    );
                                                  }}
                                                </FastField>
                                              }
                                            />
                                          )}
                                        </td>
                                        <td className="w-25 px-3">
                                          <KTFormGroup
                                            inputName="serialNumber"
                                            isRequired={true}
                                            additionalClassName="mb-0"
                                            inputElement={
                                              <FastField name={`investments.${index}.serialNumber`}>
                                                {({ field, form, meta }) => {
                                                  return (
                                                    <KTFormInput
                                                      name={field.name}
                                                      value={field.value}
                                                      onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                      }}
                                                      onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                      }}
                                                      enableCheckValid={true}
                                                      type={KTFormInputType.text}
                                                      placeholder={t('Số Seri')}
                                                      isValid={_.isEmpty(meta.error)}
                                                      isTouched={meta.touched}
                                                      feedbackText={meta.error}
                                                      disabled={false}
                                                    />
                                                  );
                                                }}
                                              </FastField>
                                            }
                                          />
                                        </td>
                                        <td className="w-25 px-3">
                                          <KTFormGroup
                                            inputName="valueNumber"
                                            isRequired={true}
                                            additionalClassName="mb-0"
                                            inputElement={
                                              <FastField name={`investments.${index}.valueNumber`}>
                                                {({ field, form, meta }) => {
                                                  return (
                                                    <KTFormInput
                                                      name={field.name}
                                                      value={field.value}
                                                      onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                      }}
                                                      onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                      }}
                                                      enableCheckValid={true}
                                                      type={KTFormInputType.currency}
                                                      placeholder={t('Số tiền')}
                                                      isValid={_.isEmpty(meta.error)}
                                                      isTouched={meta.touched}
                                                      feedbackText={meta.error}
                                                      disabled={false}
                                                    />
                                                  );
                                                }}
                                              </FastField>
                                            }
                                          />
                                        </td>
                                        <td className="w-10 pl-5">
                                          <KTBSButton
                                            color={KTBSButtonColor.secondary}
                                            title=""
                                            size={KTBSButtonSize.default}
                                            borderRadius={5}
                                            buttonTitleFontWeight="600"
                                            buttonTitleColor="#000000"
                                            additionalClassName="mr-3 w-40px h-[40px]"
                                            iconElement={
                                              <i className="fa-regular fa-trash-can w-19px h-19px pr-0" />
                                            }
                                            onPress={() =>
                                              setFieldValue(
                                                'investments',
                                                values.investments.filter((_, i) => i !== index)
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                    <div className="col-lg-3">
                                      <KTBSButton
                                        color={KTBSButtonColor.light}
                                        title={t('Thêm trụ sạc')}
                                        size={KTBSButtonSize.default}
                                        borderRadius={5}
                                        buttonTitleFontWeight="600"
                                        buttonTitleColor="rgba(73, 73, 104, 1)"
                                        buttonTitleFontSize={14}
                                        iconElement={<i className="fa-regular fa-circle-plus" />}
                                        onPress={() =>
                                          setFieldValue('investments', [
                                            ...values.investments,
                                            { id: Date.now(), value: '0' },
                                          ])
                                        }
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <table className="table table-bordered text-center">
                                      <thead className="table-light">
                                        <tr
                                          style={{
                                            borderTop: `1px solid ${AppColors.gray[300]}`,
                                            borderBottom: `1px solid #E0E0E0`,
                                          }}
                                        >
                                          <th className="fw-bold w-40 text-left">
                                            Gói đầu tư hợp tác kinh doanh
                                          </th>
                                          <th className="fw-bold w-25 text-left">Đơn giá</th>
                                          <th className="fw-bold w-10 text-left"></th>
                                        </tr>
                                      </thead>
                                    </table>
                                    {values.investments.map((pkg, index) => (
                                      <tr
                                        key={pkg.id}
                                        className="flex items-center gap-4 mb-2 w-100"
                                      >
                                        <td className="w-40">
                                          {modelList.length > 0 && (
                                            <KTFormGroup
                                              inputName={`investments.${index}.value`}
                                              inputElement={
                                                <FastField name={`investments.${index}.value`}>
                                                  {({ field, form }) => {
                                                    return (
                                                      <KTBSDropdown
                                                        toggleElement={
                                                          <button
                                                            className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                                            type="button"
                                                          >
                                                            {packageList.find(
                                                              (item) => item.value === field.value
                                                            )?.name ?? 'Chọn gói'}
                                                          </button>
                                                        }
                                                        selectedValue={field.value}
                                                        dropdownMenuItems={packageList}
                                                        dropdownMenuClassName="overflow-auto w-100"
                                                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                                                        onChange={(value) => {
                                                          form.setFieldValue(field.name, value);
                                                        }}
                                                        isDropdownForm={true}
                                                      />
                                                    );
                                                  }}
                                                </FastField>
                                              }
                                            />
                                          )}
                                        </td>
                                        <td className="w-25 px-3">
                                          <KTFormGroup
                                            inputName="valueNumber"
                                            isRequired={true}
                                            additionalClassName="mb-0"
                                            inputElement={
                                              <FastField name={`investments.${index}.valueNumber`}>
                                                {({ field, form, meta }) => {
                                                  return (
                                                    <KTFormInput
                                                      name={field.name}
                                                      value={field.value}
                                                      onChange={(value) => {
                                                        form.setFieldValue(field.name, value);
                                                      }}
                                                      onBlur={() => {
                                                        form.setFieldTouched(field.name, true);
                                                      }}
                                                      enableCheckValid={true}
                                                      type={KTFormInputType.currency}
                                                      placeholder={t('Số tiền')}
                                                      isValid={_.isEmpty(meta.error)}
                                                      isTouched={meta.touched}
                                                      feedbackText={meta.error}
                                                      disabled={false}
                                                    />
                                                  );
                                                }}
                                              </FastField>
                                            }
                                          />
                                        </td>
                                        <td className="w-10 pl-5">
                                          <KTBSButton
                                            color={KTBSButtonColor.secondary}
                                            title=""
                                            size={KTBSButtonSize.default}
                                            borderRadius={5}
                                            buttonTitleFontWeight="600"
                                            buttonTitleColor="#000000"
                                            additionalClassName="mr-3 w-40px h-[40px]"
                                            iconElement={
                                              <i className="fa-regular fa-trash-can w-19px h-19px pr-0" />
                                            }
                                            onPress={() =>
                                              setFieldValue(
                                                'investments',
                                                values.investments.filter((_, i) => i !== index)
                                              )
                                            }
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                    <div className="col-lg-3">
                                      <KTBSButton
                                        color={KTBSButtonColor.secondary}
                                        title={t('Thêm gói khác')}
                                        size={KTBSButtonSize.default}
                                        borderRadius={5}
                                        buttonTitleFontWeight="600"
                                        buttonTitleColor="#000000"
                                        additionalClassName="mr-3"
                                        iconElement={<i className="fa-regular fa-circle-plus" />}
                                        onPress={() =>
                                          setFieldValue('investments', [
                                            ...values.investments,
                                            { id: Date.now(), value: '0' },
                                          ])
                                        }
                                      />
                                    </div>
                                  </>
                                )}
                                <Col md={12}>
                                  <div
                                    className="mt-5 mb-5"
                                    style={{
                                      borderBottom: `1px dashed ${AppColors.gray[300]}`,
                                    }}
                                  />
                                </Col>
                                <div
                                  className="mt-4 text-right font-bold text-green-600 text-lg"
                                  style={{
                                    fontWeight: '700',
                                    fontSize: Utils.convertToFontSize(16),
                                  }}
                                >
                                  Thành tiền:{' '}
                                  <span
                                    style={{
                                      fontWeight: '700',
                                      fontSize: Utils.convertToFontSize(20),
                                      color: AppColors.primary,
                                    }}
                                  >
                                    {new Intl.NumberFormat('vi-VN').format(
                                      values.investments
                                        .filter((pkg) => pkg.valueNumber)
                                        .reduce((sum, pkg) => sum + Number(pkg.valueNumber), 0)
                                    )}
                                    VNĐ
                                  </span>
                                </div>
                              </div>
                            )}
                          </Formik>
                        </div>
                      )}
                    </div>
                    {/* tai lieu dinh kem */}
                    <div className="pr-lg-4 mb-2">
                      {buildCard(
                        'Tài liệu đính kèm',
                        <div className="">
                          <Col md={12} className="px-0">
                            <div
                              className="mb-3"
                              style={{
                                borderBottom: `1px solid ${AppColors.gray[300]}`,
                              }}
                            />
                          </Col>
                          {/* danh sach file dang duoc chon */}
                          {!_.isEmpty(allFiles) && (
                            <div className="row m-0 mt-2 px-5">
                              {allFiles.map((item, index) => {
                                return (
                                  <div
                                    className="col-lg-2 px-0 pr-0 pr-lg-4 pb-4 my-2 bg-white"
                                    key={item?.lastModified ?? item ?? index}
                                  >
                                    <KTOverlay
                                      wrapperEl={
                                        <div className="d-flex flex-column align-items-start gap-2">
                                          <div
                                            className="w-100 d-flex align-items-center justify-content-center"
                                            style={{
                                              aspectRatio: '16/9',
                                              border: `1px solid ${AppColors.gray[300]}`,
                                              borderRadius: '5px',
                                            }}
                                          >
                                            <img
                                              src={
                                                AppResource.icons.fileType[
                                                `icFileType${Utils.getFileExt(
                                                  item?.name ?? item
                                                )}`
                                                ] ?? AppResource.icons.fileType.icFileTypeUNKNOWN
                                              }
                                            />
                                          </div>
                                          <span
                                            style={{
                                              fontWeight: '500',
                                              fontSize: Utils.convertToFontSize(14),
                                              color: AppColors.gray[800],
                                              lineBreak: 'anywhere',
                                            }}
                                          >
                                            {item?.name ?? Utils.getFileNameFromPath(item)}
                                          </span>
                                        </div>
                                      }
                                      layerEl={
                                        <div
                                          className="w-100 h-100 d-flex justify-content-end p-2"
                                          style={{
                                            borderRadius: '10px',
                                          }}
                                        >
                                          <KTBSButton
                                            color={KTBSButtonColor.danger}
                                            size={KTBSButtonSize.small}
                                            borderRadius={50}
                                            onPress={() => {
                                              handleRemoveFile(item);
                                            }}
                                            iconElement={<i className="far fa-trash-can" />}
                                            iconOnly={true}
                                          />
                                        </div>
                                      }
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          )}
                          <div className="d-flex align-items-center gap-2 px-5">
                            <label className="">
                              <KTBSButton
                                color={KTBSButtonColor.primary}
                                title={t('Tải lên tài liệu đính kèm')}
                                size={KTBSButtonSize.default}
                                borderRadius={5}
                                buttonTitleFontWeight="600"
                                iconElement={<i className="fa-regular fa-upload" />}
                                bgColor={AppColors.primary}
                              />
                              <input
                                type="file"
                                accept={['.xls', '.xlsx', '.doc', '.docx', '.pdf']}
                                onChange={handleFilesChanged}
                                multiple
                                hidden
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                              />
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* thong tin giao dich */}
                  <div className="col-lg-4 px-0 pr-0 pb-4">
                    {buildCard(
                      'Thông tin đơn hàng',
                      <div className="">
                        <Col md={12} className="px-0">
                          <div
                            className="mb-2"
                            style={{
                              borderBottom: `1px solid ${AppColors.gray[300]}`,
                            }}
                          />
                        </Col>
                        {/* trang thai don hang */}
                        <div className="px-5">
                          <KTFormGroup
                            label={
                              <span className="font-weight-bolder">
                                {t('Trạng thái đơn hàng')}{' '}
                              </span>
                            }
                            inputName="orderStatus"
                            inputElement={
                              <FastField name="orderStatus">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTBSDropdown
                                      toggleElement={
                                        <button
                                          className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                                          type="button"
                                        >
                                          {t(`orderStatus_${field.value}`)}
                                        </button>
                                      }
                                      selectedValue={field.value}
                                      dropdownMenuItems={orderStatusOptions}
                                      dropdownMenuClassName="overflow-auto w-100"
                                      dropdownMenuStyle={{ maxHeight: '30vh' }}
                                      onChange={(value) => {
                                        console.log(field);
                                        form.setFieldValue(field.name, value);
                                      }}
                                      isDropdownForm={true}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* ngay hop dong */}
                          <KTFormGroup
                            label={
                              <span className="font-weight-bolder">{t('Ngày hợp đồng')} </span>
                            }
                            inputName="orderDate"
                            isRequired={true}
                            inputElement={
                              <FastField name="orderDate">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={false}
                                      type={KTFormInputType.date}
                                      placeholder={t('Ngày hợp đồng')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={false}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          {/* so hop dong */}
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('Số hợp đồng')} </span>}
                            inputName="orderNumber"
                            isRequired={true}
                            additionalClassName="mb-0"
                            inputElement={
                              <FastField name="orderNumber">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormInput
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={true}
                                      type={KTFormInputType.text}
                                      placeholder={t('Số hợp đồng')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={false}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                          <KTFormGroup
                            label={<span className="font-weight-bolder">{t('Ghi chú')} </span>}
                            inputName="note"
                            isRequired={true}
                            additionalClassName="mt-3"
                            inputElement={
                              <FastField name="note">
                                {({ field, form, meta }) => {
                                  return (
                                    <KTFormTextArea
                                      name={field.name}
                                      value={field.value}
                                      onChange={(value) => {
                                        form.setFieldValue(field.name, value);
                                      }}
                                      onBlur={() => {
                                        form.setFieldTouched(field.name, true);
                                      }}
                                      enableCheckValid={true}
                                      type={KTFormInputType.text}
                                      placeholder={t('Ghi chú')}
                                      isValid={_.isEmpty(meta.error)}
                                      isTouched={meta.touched}
                                      feedbackText={meta.error}
                                      disabled={false}
                                    />
                                  );
                                }}
                              </FastField>
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </div>
  );
}

export default DealerReconciliationReportDetailScreen;
